export enum DataState {
    Idle = 'Idle',
    Pending = 'Pending',
    Error = 'Error',
    Timeout = 'Timeout'
}

export enum httpResponseConstants {
    Forbidden = 'Forbidden'
}

export enum EventTypes {
    UpdateAmountEvent = 'UpdateAmountEvent',
    TeamCloseCycleEvent = 'TeamCloseCycleEvent',
    UpdatePromotionJobEvent = 'UpdatePromotionJobEvent',
    UpdatePromotionRequestNewTitleEvent = 'UpdatePromotionRequestNewTitleEvent',
    WorkflowApproveEvent = 'WorkflowApproveEvent',
    WorkflowSubmitEvent = 'WorkflowSubmitEvent',
    WorkflowSendBackEvent = 'WorkflowSendBackEvent',
    UpdateBudgetEvent = 'UpdateBudgetEvent',
    UpdatePerformanceRating = 'UpdatePerformanceRating',
    UpdatePromotionRequestAmountEvent = 'UpdatePromotionRequestAmountEvent',
    OverrideAmountEligibilityEvent = 'OverrideAmountEligibilityEvent',
    OverrideAmountProrationEvent = 'OverrideAmountProrationEvent',
    CreateEmployeeConversationEvent = 'CreateEmployeeConversationEvent',
    AddPromotionRequestConversationEvent = 'AddPromotionRequestConversationEvent',
    TeamNotifyManagersEvent = 'TeamNotifyManagersEvent',
    Terminate = 'Terminate',
    RemoveUserEvent = 'RemoveUserEvent'
}

export enum EntityTypes {
    PromotionRequest = 'PromotionRequest',
    EmployeeCycle = 'EmployeeCycle',
    TeamCycle = 'TeamCycle',
    ManagerWorkflow = 'ManagerWorkflow',
    Employee = 'Employee'
}

export enum ConversationEntityType {
    Employee = 'Employee',
    PromotionRequest = 'PromotionRequest'
}

export enum EmployeeClass {
    Annual = 'Annual',
    Hourly = 'Hourly'
}

export enum WorkflowReviewerType {
    Employee = 'employee',
    User = 'user'
}

export enum AmountCode {
    Merit = 'merit',
    Bonus = 'bonus',
    LumpSum = 'lumpSum',
    MarketAdjustment = 'marketAdjustment',
    Promotion = 'promotion',
    Stock = 'stock',
    VariablePay = 'variablePay'
}

export enum AmountPayType {
    BasePay = 'basePay',
    OneTime = 'oneTime',
    None = 'none'
}

export enum FeatureFlags {
    ShowPayHistory = 'show-pay-history',
    ShowUnificationTabs = 'show-unification-tabs',
    JobCollabOnly = 'job-collab-only',
    MobxCycleSettings = 'mobx-cycle-settings',
    TeamDown = 'team-down',
    ShowDataSummary = 'show-data-summary',
    EmployeesPerPage = 'employees-per-page',
    ShowContactForm = 'show-contact-form',
    ShowCaseDeflection = 'show-case-deflection',
    ShowDataErrorBanner = 'show-data-error-banner',
    ShowHideIneligibleEmployees = 'show-hide-ineligible-employees',
    ShowCompMemo = 'show-comp-memo',
    TeamPayJobsList = 'team-pay-jobs-list'
}

export enum EmployeeNameFormat {
    FirstName = 'FirstName',
    FirstNameLastName = 'FirstNameLastName',
    FirstNameMiddleInitialLastName = 'FirstNameMiddleInitialLastName',
    LastNameFirstName = 'LastNameFirstName',
    LastNameFirstNameMiddleInitial = 'LastNameFirstNameMiddleInitial'
}

export enum PayRangeDisplayType {
    RangePenetration = 'Range Penetration',
    CompaRatio = 'Compa - Ratio'
}

export enum CompaRatioDisplayFormat {
    ShowAsDecimal = '1.00',
    ShowAsPercentage = '100.00%'
}

export enum BaseOfCalculation {
    BasePay = 'Base Pay',
    TCC = 'TCC'
}

export enum RoundingMethod {
    Absolute = 'Absolute',
    RoundDown = 'RoundDown',
    RoundUp = 'RoundUp'
}

export enum StockDisplayType {
    Unit = 'Unit Value',
    Monetary = 'Monetary Value'
}

export enum WorkflowStatus {
    Open = 'Open',
    InProgress = 'In Progress',
    PendingReview = 'Pending Review',
    Approved = 'Approved'
}

export enum SidePanelListType {
    WorkflowStatus = 'workflowstatus',
    OverBudget = 'overbudget'
}

export enum WorkflowStatusListType {
    Open = 'open',
    InProgress = 'inprogress',
    Pending = 'pending',
    Approved = 'approved'
}

export enum ReportsView {
    DirectsOnly = 'directs',
    AllReports = 'all'
}

export enum Roles {
    HumanResource = 'HR Admin',
    Manager = 'Manager',
    ManagerOfManager = 'ManagerOfManager',
    Support = 'Support',
    Hrbp = 'HRBP',
    TeamDev = 'TeamDev'
}

export enum ConfigViews {
    Cycle = 'cycle',
    Budget = 'budget',
    Workflow = 'workflow'
}

export enum WorkflowTabs {
    HrRoles = 'hrroles',
    WorkflowConfiguration = 'workflowconfiguration',
    NoWorkflow = ''
}

export enum RuleCode {
    FollowHierarchy = 'WorkflowRuleFollowHierarchy',
    ImmediateManager = 'WorkflowRuleImmediateManager',
    GoToFieldLeader = 'WorkflowRuleGoToFieldLeader',
    HumanResourceApprover = 'WorkflowRuleGoToHrApprover',
    HumanResourceReviewer = 'WorkflowRuleGoToHrReviewer'
}

export enum RuleField {
    Division = 'Division',
    BusinessUnit = 'BusinessUnit',
    Department = 'Department',
    Ceo = 'CEO',
    LevelBelowCeo = 'LevelBelowCeo'
}

export enum EligibilityProrationTabs {
    EligibilityRule = 'eligibilityrule',
    ProrationRule = 'prorationrule'
}

export enum EligibilityRuleFilters {
    HireDate = 'Hire Date',
    PayEffectiveDate = 'Pay Effective Date',
    AnniversaryDate = 'Anniversary Date',
    Department = 'Department',
    WorkLocation = 'Work Location'
}

export enum EligibilityRuleType {
    Annual = 1,
    Anniversary = 2
}

export enum MonthStrings {
    January = 'January',
    February = 'February',
    March = 'March',
    April = 'April',
    May = 'May',
    June = 'June',
    July = 'July',
    August = 'August',
    September = 'September',
    October = 'October',
    November = 'November',
    December = 'December'
}

export enum ProrationRuleFilters {
    HireDate = 'Hire Date',
    PayEffectiveDate = 'Pay Effective Date'
}

export enum Views {
    DirectReport = 'directonly',
    AllReport = 'allreport',
    ChangeHistory = 'changehistory',
    OrgChart = 'orgchart'
}

export enum EmployeeCardTabs {
    CycleInfo = 'cycleinfo',
    PayHistory = 'payhistory',
    EmployeeInfo = 'employeeinfo',
    PromotionRequest = 'promotionrequest'
}

export enum ConfigTabs {
    HRBP = 'HRBP',
    EMPLOYEE = 'Employee',
    DATA = 'DataSummary'
}

export enum ProrateMethod {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly'
}

export enum ChangeHistoryItem {
    ChangeHistoryEmployeeCycle = 'ChangeHistoryEmployeeCycle',
    ChangeHistoryPromotionRequestDelete = 'ChangeHistoryPromotionRequestDelete',
    ChangeHistoryWorkflowApprove = 'ChangeHistoryWorkflowApprove',
    ChangeHistoryWorkflowSendBack = 'ChangeHistoryWorkflowSendBack',
    ChangeHistoryWorkflowSubmit = 'ChangeHistoryWorkflowSubmit'
}

export enum CycleBudgetFieldOrdinal {
    Merit = 1,
    Bonus = 2,
    LumpSum = 4,
    MarketAdjustment = 3,
    Promotion = 5,
    Stock = 7,
    VariablePay = 6
}

export enum MainViewPriority {
    Merit = 1,
    Bonus = 2,
    LumpSum = 3,
    MarketAdjustment = 4,
    VariablePay = 5,
    Stock = 6
}

export enum AmountColor {
    Increase = '#05678F',
    Bonus = '#0FB2F6',
    Promotion = '#00AAA4',
    VariablePay = '#235090',
    LumpSum = '#5A3580',
    MarketAdjustment = '#7E4AB2',
    Stock = '#9D1371'
}

export enum PercentageCalculationRule {
    PercentageOfTarget = 'PercentageOfTarget',
    PercentageOfCurrentPay = 'PercentageOfCurrentPay'
}

export const PercentageCalculationRuleOptions: Array<ISelectOption<PercentageCalculationRule>> = Array.of(...[
    {
        value: PercentageCalculationRule.PercentageOfCurrentPay,
        text: 'Current Pay'
    }, {
        value: PercentageCalculationRule.PercentageOfTarget,
        text: 'Bonus Target'
    }
]);

export enum TargetSource {
    SetBudget = 'SetBudget',
    EmployeeData = 'EmployeeData'
}

export enum CycleStatus {
    Pending = 'Pending',
    Open = 'Open',
    Closed = 'Closed',
    Closing = 'Closing',
    Published = 'Published'
}

export enum ReviewType {
    Current = 'Current',
    Next = 'Next',
    Approved = 'Approved'
}

export enum CustomFieldType {
    Text = 'text',
    Monetary = 'monetary',
    Number = 'number',
    Timestamp = 'timestamp',
    Percent = 'percent',
    Integer = 'integer',
    Boolean = 'boolean',
    Date = 'date'
}

export enum EmployeePayType {
    LastPaidSti = 'lastPaidSti',
    OtherCash = 'otherCash',
    Commissions = 'commisions'
}

export enum EmployeePayTypeTitle {
    LastPaidSti = 'Last Paid STI',
    OtherCash = 'Other Cash',
    Commissions = 'Commissions'
}

export enum EmployeeLevelEnum {
    Department = 'Department',
    BusinessUnit = 'BusinessUnit',
    Division = 'Division'
}

export enum AssignedUserLevel {
    HrApprover = 'HR Approver',
    HrAssistant = 'HR Assistant',
    HrReviewer = 'HR Reviewer'
}

export const enum BasePayRangeId {
    BelowMin = 'Below Min',
    WithinRange = 'Within Range',
    AboveMax = 'Above Max'
}

export enum BasePayRangeIdNumber {
    BelowMin = 1,
    WithinRange = 2,
    AboveMax = 3
}

export enum TeamRoutes {
    Decision = '/cycles/managers/managerview',
    ChangeHistory = '/cycles/changehistory',
    EmployeeDecision = '/mobx/cycles/employees',
    AccessDenied = '/Account/AccessDenied',
    CycleSettings = '/mobx/cycles/cycleSettings',
    MstCycleConfig = '/configuration/cycle',
    CycleNotOpenManagerView = '/cycleNotOpen',
    Diagnostics = '/diagnostics',
    TeamDown = '/unavailable',
    SummaryDashboard = '/cycles',
    MobxManager = '/cycles/managers/managerview',
    GlobalConfiguration = '/configuration/global',
    CycleConfiguration = '/configuration/cycle',
    Support = '/support',
    InvalidAccount = '/Account/Invalid',
    NotFound = '/Error/NotFound/:code',
    Error = '/Error',
    Logout = '/logout',
    AccountError = '/accountError',
    HelpArticles = '/help',
    JobsList = '/jobs',
    JobDetails = '/jobDetails',
    EmployeesList = '/employees',
    EmployeeDetailsView = '/employeeDetails',
    Print = '/print'
}

export enum NavigationErrors {
    Default = 'You\'ve experienced an error. Please try again later.',
    NoManagerRoles = 'Your user has not been assigned a manager role.',
    NoRoles = 'Your user currently has no roles assigned.',
    NoReports = 'You currently have no one reporting to you.'
}

export enum FieldDisplayName  {
    FirstName = 'First Name',
    LastName = 'Last Name',
    JobTitleInternal = 'Job Title',
    EmployeeSourceId = 'Employee ID',
    HireDate = 'Hire Date',
    ManagerSourceId = 'Manager Id',
    WorkEmail = 'Email Address',
    AnnualOrHourly = 'Pay Type',
    IsoCurrencyCode = 'Currency Code',
    CountryCode = 'Country Code',
    StandardWorkHours = 'Work Hours',
    MissingUser = 'Missing User',
    DuplicateEmail = 'Duplicate Email',
    All = 'All'
}

export enum FieldName  {
    FirstName = 'firstName',
    LastName = 'lastName',
    JobTitleInternal = 'jobTitleInternal',
    EmployeeSourceId = 'employeeSourceId',
    HireDate = 'hireDate',
    ManagerSourceId = 'managerSourceId',
    WorkEmail = 'workEmail',
    AnnualOrHourly = 'annualOrHourly',
    IsoCurrencyCode = 'isoCurrencyCode',
    CountryCode = 'countryCode',
    StandardWorkHours = 'standardWorkHours',
    MissingUser = 'missingUser',
    DuplicateEmail = 'duplicateEmail',
    All = 'All'
}

export enum DataSummaryTabs {
    DataErrors = 'Data Errors',
    DeletedEmployees = 'Deleted Employees'
}

export enum BudgetSettingModalViews {
    Create = 'create',
    Edit = 'edit'
}

export interface ILabAmountCodes {
    Merit: AmountCode.Merit,
    Bonus: AmountCode.Bonus,
    VariablePay: AmountCode.VariablePay,
    Stock: AmountCode.Stock
}

export const LabAmountCodes = {
    'merit': AmountCode.Merit,
    'bonus': AmountCode.Bonus,
    'variablePay': AmountCode.VariablePay,
    'stock': AmountCode.Stock
} as {[key: string]: AmountCode};

export enum PageTabs {
    Overview = 'overview',
    Teams = 'teams',
    Employees = 'employees',
    Jobs = 'jobs',
    Settings = 'settings'
}

export enum BudgetGroupingOptions {
    Department = 'department',
    BusinessUnit = 'businessUnit',
    WorkLocation = 'workLocation',
    All = 'all'
}

export enum NotificationCategory {
    TeamToReview = 'Team to review',
    PromotionRequest = 'Promotion request',
    YourTeam = 'Your team',
    Message = 'Message'
}

export enum NotificationName {
    NotificationDataWorkflowSendReview = 'NotificationDataWorkflowSendReview',
    NotificationDataWorkflowSendBack = 'NotificationDataWorkflowSendBack',
    NotificationDataPromotionRequestForReview = 'NotificationDataPromotionRequestForReview',
    NotificationDataPromotionRequestUpdated = 'NotificationDataPromotionRequestUpdated',
    NotificationDataPromotionRequestComment = 'NotificationDataPromotionRequestComment',
    NotificationDataConversationAdded = 'NotificationDataConversationAdded',
    NotificationDataWorkflowApproved = 'NotificationDataWorkflowApproved'
}

export enum IEmployeeViewNavigationEnum {
    cycleId = 'CycleId',
    managerSourceIds = 'ManagerSourceIds',
    workflowStatus = 'WorkflowStatus',
    reportsView = 'ReportsView',
    showSidePanel = 'ShowSidePanel',
    sortBy = 'SortBy',
    promotionFilter = 'PromotionFilter',
    jobTitleFilter = 'JobTitleFilter',
    departmentFilter = 'DepartmentFilter',
    selectedEmployee = 'SelectedEmployee',
    queryParameters = 'QueryParameters',
}